import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type EyeOpenIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function EyeOpenIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: EyeOpenIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
     <Path
        d="M2.899 12.735a1.872 1.872 0 010-1.47c.808-1.92 2.1-3.535 3.716-4.647C8.232 5.506 10.103 4.945 12 5.004c1.897-.059 3.768.502 5.385 1.614C19 7.73 20.293 9.345 21.1 11.265a1.872 1.872 0 010 1.47c-.808 1.92-2.1 3.535-3.716 4.647-1.617 1.112-3.488 1.673-5.385 1.614-1.897.059-3.768-.502-5.385-1.614C5 16.27 3.707 14.655 2.9 12.735z"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 15.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default EyeOpenIcon;
